module.exports = "<small *ngIf=\"text.length > 0\" class=\"text-form\" [innerHTML]=\"text\"></small>\n"